import { render, staticRenderFns } from "./theme-configuration.vue?vue&type=template&id=f36069fc&scoped=true&"
import script from "./theme-configuration.vue?vue&type=script&lang=js&"
export * from "./theme-configuration.vue?vue&type=script&lang=js&"
import style0 from "./theme-configuration.vue?vue&type=style&index=0&id=f36069fc&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36069fc",
  null
  
)

export default component.exports